import React from "react";
import Site from "../../model/Site";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import { useNavigate } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import ImgUtil from "../../utils/ImgUtil";
import EntityStats from "../../model/EntityStats";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";

interface ISitesListElementProps {
  data: Site;
  canEdit: boolean;
}

function SitesListElement({ data, canEdit }: ISitesListElementProps) {
  const navigate = useNavigate();

  const handleNavigateToDetails = () => {
    navigate(
      SETTINGS.get_path({
        section: AppSections.SITES,
        id: data.id,
        subsection: AppSubSections.VIEW,
      }),
    );
  };

  return (
    <div className="list-row" onClick={handleNavigateToDetails}>
      {data.icon && (
        <div
          className="list-row-icon"
          style={{
            backgroundImage: `url(${ImgUtil.display_icon(data.icon_path)})`,
          }}
        ></div>
      )}

      <div className="list-row-content">
        <div className="list-row-header">
          <div className="list-row-title">
            <h3>{data.name}</h3>
          </div>
          <div>
            {canEdit && (
              <Button
                label="Edit"
                purpose={ButtonAction.EDIT}
                type={ButtonType.ICON_TEXT}
                onClick={() => {
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.SITES,
                      id: data.id,
                      subsection: AppSubSections.EDIT,
                    }),
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="list-row-description">{data.description}</div>
        <div className="list-row-footer">
          <ButtonInfo>
            {AppIcons.CH_ELEMENT}
            <span>
              {EntityStats.getStats(data.counts, ChemiNovaEntityType.CHELEMENT)}
            </span>{" "}
            Cultural Heritage Assets
          </ButtonInfo>
          <ButtonInfo>
            {AppIcons.USER}
            created by: <span>{data.username}</span>
          </ButtonInfo>
        </div>
      </div>
    </div>
  );
}

export default SitesListElement;
